import { lazy, FC } from 'react';
import { useFragment, graphql } from 'react-relay';

// components
import { FormattedNumber } from 'dibs-react-intl';
import { ClientSuspense } from 'dibs-elements/exports/ClientSuspense';

// helpers
import { useAuctionPricing } from 'dibs-auctions/exports/hooks/useAuctionPricing';

// types
import { SharedAuctionPrice_item$key } from './__generated__/SharedAuctionPrice_item.graphql';

// styles
import styles from './SharedAuctionPrice.scss';

const PaddleIcon = lazy(
    () => import(/* webpackChunkName: "PaddleIcon" */ 'dibs-icons/exports/Paddle')
);

const itemFragment = graphql`
    fragment SharedAuctionPrice_item on Item {
        ...useAuctionPricing_item @arguments(page: null)
    }
`;

type Props = {
    item: SharedAuctionPrice_item$key;
    currency: string;
};

export const SharedAuctionPrice: FC<Props> = ({ item: itemRef, currency }) => {
    const item = useFragment(itemFragment, itemRef);
    const { currentBidAmount, startingBidAmount } = useAuctionPricing({ item, currency });

    const amount = currentBidAmount || startingBidAmount;

    if (!amount) {
        return null;
    }

    return (
        <div className={styles.priceWrapper}>
            <ClientSuspense fallback={null}>
                <PaddleIcon className={styles.paddle} />
                <FormattedNumber
                    value={amount}
                    currency={currency}
                    style="currency"
                    minimumFractionDigits={0}
                    maximumFractionDigits={0}
                />
            </ClientSuspense>
        </div>
    );
};
